import { render, staticRenderFns } from "./ed-text-viewer.vue?vue&type=template&id=68f8efdb&scoped=true&"
import script from "./ed-text-viewer.ts?vue&type=script&lang=ts&"
export * from "./ed-text-viewer.ts?vue&type=script&lang=ts&"
import style0 from "./ed-text-viewer.scss?vue&type=style&index=0&id=68f8efdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f8efdb",
  null
  
)

export default component.exports